module.exports = "/next-static/_next/static/images/hero_image_small-c74257ccf7d7cead0e1ceabd25934638.webp";